// extracted by mini-css-extract-plugin
export default {"zoomControls":"C--z","zoomControlButton":"D--z","zoomBanner":"E--z","bannerButton":"F--z","imageButton":"G--z","zoom":"H--z","zoomContent":"I--z"};